import { GridColDef } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TachographCompanyCardRow } from "../models/Tachograph";
import { TACHOGRAPH_PAGE_SIZES } from "./tachographGridDefaults";
import { I18nGrid } from "@/components/data/I18nGrid";

type Props = {
  rows: TachographCompanyCardRow[];
  loading: boolean;
};

/** The company cards in use, with their validity. */
export function TachographCompanyCardGrid({ rows, loading }: Props) {
  const { t } = useTranslation();

  const columns = useMemo<GridColDef<TachographCompanyCardRow>[]>(
    () => [
      { field: "cardNumber", headerName: t("tachograph.columns.cardNumber"), minWidth: 220, flex: 1 },
      {
        field: "companyName",
        headerName: t("tachograph.columns.companyName"),
        minWidth: 260,
        flex: 1,
      },
      { field: "icc", headerName: t("tachograph.columns.icc"), minWidth: 180, flex: 0.8 },
      { field: "status", headerName: t("tachograph.columns.status"), minWidth: 130, flex: 0.7 },
      { field: "source", headerName: t("tachograph.columns.source"), minWidth: 190, flex: 0.8 },
      { field: "validFrom", headerName: t("tachograph.columns.validFrom"), minWidth: 140, flex: 0.7 },
      {
        field: "expiryDateUtc",
        headerName: t("tachograph.columns.expiryDateUtc"),
        minWidth: 160,
        flex: 0.8,
      },
      { field: "lastUpdate", headerName: t("tachograph.columns.lastUpdate"), minWidth: 190, flex: 0.8 },
    ],
    [t],
  );

  return (
    <I18nGrid
      rows={rows}
      columns={columns}
      loading={loading}
      density="compact"
      disableRowSelectionOnClick
      pageSizeOptions={TACHOGRAPH_PAGE_SIZES}
      initialState={{ sorting: { sortModel: [{ field: "cardNumber", sort: "asc" }] } }}
    />
  );
}
